import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  ModalAction,
  ModalBody,
  ModalButton,
} from '../../../../../../components/Modal/Modal';
import { trans } from '../../../../../../localization';
import { changeRestaurantOfOrder, stopTransferringOrder } from '../actions';
import { isEmpty } from '../../../../../../utils/utils';

class TransferOrderConfirm extends Component {
  handleBranchChange = () => {
    const {
      transferredOrder,
      selectedBranch,
      newBranchData,
      changeRestaurantOfOrderConnect,
    } = this.props;
    const { code } = transferredOrder || {};
    const { restaurant_id: restaurantId, name, address } = selectedBranch || {};
    const { confirm_code: confirmCode } = newBranchData || {};

    if (!isEmpty(code) && !isEmpty(restaurantId) && !isEmpty(confirmCode)) {
      changeRestaurantOfOrderConnect(
        code,
        restaurantId,
        confirmCode,
        `${name} - ${address}`,
      );
    }
  };

  render() {
    const {
      transferredOrder,
      selectedBranch,
      newBranchData,
      stopTransferringOrderConnect,
    } = this.props;
    const { deliver_address: deliverAddress, order_user: orderUser } =
      transferredOrder || {};
    const {
      contact_name: receiverName,
      phone: receiverPhone,
      orderer_phone: ordererPhone,
    } = deliverAddress || {};
    const { name: ordererName } = orderUser || {};
    const {
      name: selectedBranchName,
      address: selectedBranchAddress,
    } = selectedBranch;
    const { order_amount: orderAmount } = newBranchData || {};
    const { sub_total: subTotal, merchant_paid_amount: merchantPaidAmount } =
      orderAmount || {};
    const { text: newSubTotalText } = subTotal || {};
    const { text: newMerchantPaidAmountText } = merchantPaidAmount || {};

    return (
      <Fragment>
        <ModalBody className="modal-confirm-transfer-order">
          <div>{trans('check_order_before_transferring')}</div>
          <div className="gray-color-text">
            {trans('please_call_transferred_branch_and_customer')}
          </div>

          <div className="receiver-and-orderer-info">
            <div className="receiver-info">
              <div className="name-and-role font-weight-bold">
                {receiverName && `${receiverName} (${trans('receiver')})`}
              </div>
              <div className="phone">{receiverPhone}</div>
            </div>

            <div className="customer-info">
              <div className="name-and-role font-weight-bold">
                {ordererName && `${ordererName} (${trans('orderer')})`}
              </div>
              <div className="phone">{ordererPhone}</div>
            </div>
          </div>

          <div>{trans('transferred_branch')}</div>
          <div className="font-weight-bold branch-name">
            {`${selectedBranchName} - ${selectedBranchAddress}`}
          </div>

          <div>{trans('new_total_merchant')}</div>
          <div className="font-weight-bold new-total">
            {newMerchantPaidAmountText}
          </div>

          <div>{trans('new_total_user')}</div>
          <div className="font-weight-bold new-total">{newSubTotalText}</div>
        </ModalBody>

        <ModalAction>
          <ModalButton
            className="text-blue button-cancel"
            onClick={stopTransferringOrderConnect}
          >
            {trans('common_cancel')}
          </ModalButton>
          <ModalButton
            className="btn-blue button-confirm"
            onClick={this.handleBranchChange}
          >
            {trans('transfer_order')}
          </ModalButton>
        </ModalAction>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  transferredOrder: state.transferOrder.transferredOrder,
  selectedBranch: state.transferOrder.selectedBranch,
  newBranchData: state.transferOrder.newBranchData,
});

const mapDispatchToProps = {
  stopTransferringOrderConnect: stopTransferringOrder,
  changeRestaurantOfOrderConnect: changeRestaurantOfOrder,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferOrderConfirm);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/components/TransferOrderConfirm.jsx